<div  class="business-unification-details-root" *transloco="let t">

  <div *ngIf="this.businessUnification">

    <div class="business-unification-details-title">
      Business Unification Details
    </div>

    <div class="header-line">

      <div class="country-item">
        <span [class]="'fi fi-' + this.businessUnification.businessDestination.country!.initials.toLowerCase()"></span>
        <span class="country-name">
          {{this.businessUnification.businessDestination.country.name}}
        </span>
        
      </div>

      <div class="status-item">
        <app-business-unification-status [status]="this.businessUnification.status">
        </app-business-unification-status>
      </div>

      <div *ngIf="this.businessUnification.status === 'PENDING'" class="actions-list">
        <div class="unification-action" *ngIf="this.businessUnification.status === 'PENDING'">
          <button class="action-button accept-button"
                  mat-icon-button
                  (click)="acceptUnification(this.businessUnification.id)"
                  [matTooltip]="t('accept')">
            <nb-icon icon="checkmark-circle-2-outline"></nb-icon>
          </button>
        </div>
        <div class="unification-action" *ngIf="this.businessUnification.status === 'PENDING'">
          <button class="action-button reject-button"
                  mat-icon-button
                  (click)="rejectUnification(this.businessUnification.id)"
                  [matTooltip]="t('reject')">
            <nb-icon icon="close-circle-outline"></nb-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="business-unification-table">

      <div class="table-line subheader">
        <div class="business-name">
          Business Name
        </div>
        <div class="business-points">
          Points
        </div>
        <div class="business-representatives">
          Active 
          Representatives
        </div>
        <div class="business-equipments">
          Equipments
        </div>
        <div class="business-unification-role">
          Role
        </div>
      </div>

      <mat-divider></mat-divider>

      <div>
        <div *ngFor="let item of this.businessUnification.businessesOrigins" class="table-line">
          <div class="business-name">
            {{item.businessName}}
          </div>
          <div class="business-points">
            {{item.totalPoints}}
          </div>
          <div class="business-representatives">
            {{item.totalRepresentatives}}
          </div>
          <div class="business-equipments">
            {{item.totalEquipments}}
          </div>
          <div class="business-unification-role">
            {{defineBusinessRole(item.id)}}
          </div>
        </div>
      </div>

      <mat-divider></mat-divider>

      <div>
        <div class="table-line merged-line">
          <div class="business-name">
            {{this.businessUnification.businessDestination.businessName}} (Unified)
          </div>
          <div class="business-points">
            {{this.businessUnification.totalPoints}}
          </div>
          <div class="business-representatives">
            {{this.countFinalTotalRepresentatives()}}
          </div>
          <div class="business-equipments">
            {{this.countFinalTotalEquipments()}}
          </div>
          <div class="business-unification-role">
            Unified
          </div>
        </div>
      </div>

    </div>

    <div class="unification-footer">
      <div class="status-change-item">
        <div>
          Requested By  
        </div>
        <div class="status-change-name">
          {{this.businessUnification.submittedByEmail}} ({{this.businessUnification.submissionDate | date : 'dd MMM y HH:mm:ss' : '' : getLanguage()}})
        </div>
      </div>
      <div class="status-change-item" *ngIf="this.businessUnification.reviewedByEmail">
        <div>
          Reviewed By  
        </div>
        <div class="status-change-name">
          {{this.businessUnification.reviewedByEmail}} ({{this.businessUnification.reviewDate | date : 'dd MMM y HH:mm:ss' : '' : getLanguage()}})
        </div>
      </div>
      <div class="status-change-item" *ngIf="this.businessUnification.mergedBy">
        <div>
          Merged By  
        </div>
        <div class="status-change-name">
          {{this.businessUnification.mergedBy}} ({{this.businessUnification.mergedDate | date : 'dd MMM y HH:mm:ss' : '' : getLanguage()}})
        </div>
      </div>
    </div>

  </div>

</div>
